import React from 'react';
import _ from 'lodash';
import Pagination from 'react-js-pagination';
import PropTypes from 'prop-types';
import { PaginationWrapper } from "styles/components/pagination"

const CustomPagination = ({
  currentPage,
  totalPage,
  onPageChange,
  itemsCountPerPage,
}) => {

  return (
    <PaginationWrapper>
      <Pagination
        itemClass='page-item'
        linkClass='page-link'
        hideFirstLastPages
        activePage={currentPage}
        totalItemsCount={totalPage}
        itemsCountPerPage={itemsCountPerPage}
        onChange={(value) => {
          _.isFunction(onPageChange) && onPageChange(value)
        }
        }
      />
    </PaginationWrapper>
  )
}
CustomPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPage: PropTypes.number,
  onPageChange: PropTypes.func,
  itemsCountPerPage: PropTypes.number,
};

export default CustomPagination;